import type { TabsPassThroughOptions } from "primevue/tabs";

export const tabs: TabsPassThroughOptions = {
  root: ({ props }) => ({
    class: [
      "flex flex-col",
      { "[&>[data-pc-name=tablist]]:overflow-hidden": props.scrollable }
    ]
  })
};
